module.exports = __webpack_public_path__ + "static/media/img-af67e586.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/pcw-logo.png
// module id = 5296
// module chunks = 39